import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  statusUpdates: {},
  lastUpdated: null,
};

const trackStatusSlice = createSlice({
  name: "trackStatus",
  initialState,
  reducers: {
    updateTrackStatus(state, action) {
      const { order_id, track_status } = action.payload;
      state.statusUpdates[order_id] = track_status;
      state.lastUpdated = new Date().toISOString();
    },
    clearStatusUpdates(state) {
      state.statusUpdates = {};
    },
  },
});

export const { updateTrackStatus, clearStatusUpdates } =
  trackStatusSlice.actions;
export default trackStatusSlice.reducer;
